import React, { FunctionComponent } from 'react'
import { Text } from '@wework/dieter-ui'
import css from './ScheduleTag.module.scss'

export type ScheduleTags =
  | 'PHYSICAL'
  | 'HOTDESK'
  | 'DIGITAL'
  | 'PXWE'
  | 'GLOBAL ACCESS'
  | 'EMPLOYEE'
  | 'ON DEMAND'
  | 'ON DEMAND SUBSCRIPTION'

interface TagColorScheme {
  backgroundColor: string
  textColor: string
}

interface ScheduleTagProps {
  type: ScheduleTags
}

const ScheduleTag: FunctionComponent<ScheduleTagProps> = ({ type }) => {
  const _colorScheme: Map<ScheduleTags, TagColorScheme> = new Map([
    ['PHYSICAL', { backgroundColor: '#E5FFFD', textColor: '#00665D' }],
    ['HOTDESK', { backgroundColor: '#E8FFE5', textColor: '#096600' }],
    ['DIGITAL', { backgroundColor: '#FFE5E8', textColor: '#660008' }],
    ['PXWE', { backgroundColor: '#FFF0E5', textColor: '#662B00' }],
    ['GLOBAL ACCESS', { backgroundColor: '#FDE5FF', textColor: '#5E0066' }],
    ['EMPLOYEE', { backgroundColor: '#F4FFE5', textColor: '#3C6600' }],
    ['ON DEMAND', { backgroundColor: '#F0E5FF', textColor: '#2A0066' }],
    [
      'ON DEMAND SUBSCRIPTION',
      { backgroundColor: '#FFE5F4', textColor: '#66003C' },
    ],
  ])

  const colors = _colorScheme.get(type)!

  return (
    <Text
      className={css.scheduleTag}
      style={{
        backgroundColor: colors?.backgroundColor,
        color: colors?.textColor,
      }}
    >
      {type}
    </Text>
  )
}

export default ScheduleTag
